import { deserialize, primitive, serializable } from 'serializr';
import { PhoneNumberMessagesStatus } from '@enums/phone-number-messages-status.enum';
import { PageObject } from './page-object.model';
import { Base } from './base.model';

export class PhoneNumberMessage extends Base implements PageObject {
  @serializable(primitive())
  phoneNumberId: number;
  @serializable(primitive())
  status: PhoneNumberMessagesStatus;
  @serializable(primitive())
  message: string;
  @serializable
  entityId: number;
  @serializable
  messageEntityType: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PhoneNumberMessage, input));
  }

  get received() {
    return this.status == PhoneNumberMessagesStatus.RECEIVED;
  }

  get waiting() {
    return this.status == PhoneNumberMessagesStatus.WAITING_FOR_MESSAGE;
  }

  get notReceived() {
    return this.status == PhoneNumberMessagesStatus.NOT_RECEIVED;
  }
}
